export default {
    ppage: 'max-sm:px-4 md:px-6'
}